import getConfig from 'next/config'
import fetch from 'isomorphic-unfetch'
import { fetchList } from './utils'

export const fetchPlaces = (page, filters, limit, language, userToken) => {
  if (!filters.ordering) filters.ordering = 'name' // eslint-disable-line
  return fetchList(page, filters, 'places_lite', limit, language, userToken)
}

const { publicRuntimeConfig, serverRuntimeConfig } = getConfig()

const getSingleStageUrl = '/api/v1/places_lite/'

export const fetchSinglePlace = async ({ id }, language, userToken) => {
  const token = userToken
  let placeUrl = getSingleStageUrl
  if (serverRuntimeConfig && serverRuntimeConfig.serverAddress) {
    placeUrl = `${serverRuntimeConfig.serverAddress}${placeUrl}`
  }

  if (id) {
    placeUrl = `${placeUrl}${id}/`
  }

  try {
    const headers = {
      Authorization: token ? `JWT ${token}` : undefined,
      Accept: 'application/json',
      'Accept-Language': language,
      Secret: publicRuntimeConfig.secret
    }

    const placeRes = await fetch(placeUrl, {
      headers
    })

    const place = await placeRes.json()

    if (place && place.id) {
      return place
    }
    return {}
  } catch (error) {
    console.error(error)
  }
  return null
}
